export default {
    "psw": "የይለፍ ቃል",
    "topFive": "ቅድመ 5",
    "confPsw": "የይለፍ ቃል አረጋግጥ",
    "newPsw": "አዲስ የይለፍ ቃል",
    "email": "ኢሜይል",
    "emailId": "የኢሜል መታወቂያ",
    "submit": "አስገባ",
    "cancel": "ሰርዝ",
    "faqs": "በየጥ",
    "id": "መታወቂያ",
    "processor": "ፕሮሰሰር",
    "cuppingScore": "የቅምሻ ነጥብ",
    "label": "መለያ",
    "expiry": "ጊዜው ያለፈበት",
    "users": "ተጠቃሚዎች",
    "language": "ቋንቋ",
    "appUser": "የመተግበሪያ ተጠቃሚ",
    "app_users": "የመተግበሪያ ተጠቃሚዎች",
    "offline_users": "ከመስመር ውጭ ተጠቃሚዎች",
    "dimitraAdmin": "ዲሚትራ አስተዳዳሪ",
    "admin_users": "የአስተዳዳሪ ተጠቃሚዎች",
    "search": "ፈልግ",
    "searchBy": "ፈልግ {type}",
    "firstName": "የመጀመሪያ ስም",
    "lastName": "የአያት ስም",
    "mobile": "ሞባይል",
    "mobileNumber": "ስልክ ቁጥር",
    "department": "መምሪያ",
    "role": "ሚና",
    "status": "ሁኔታ",
    "permission": "ፈቃዶች",
    "activity_log": "የእንቅስቃሴ ምዝግብ ማስታወሻ",
    "profile_auth": "የመገለጫ ማረጋገጫ",
    "countryCode": "የአገር መለያ ቁጥር",
    "selectDept": "ክፍል ይምረጡ",
    "selectRole": "ሚና ይምረጡ",
    "edit": "አርትዕ",
    "update": "አዘምን",
    "delete": "ሰርዝ",
    "view": "ይመልከቱ",
    "deactivate": "አቦዝን",
    "activate": "አግብር",
    "serverError": "የሆነ ስህተት ተከስቷል. እባክዎ ከተወሰነ ጊዜ በኋላ ይሞክሩ።",
    "minute": "ደቂቃ",
    "perHour": "በ ሰዓት",
    "day": "ቀን",
    "enterDescription": "መግለጫህን እዚህ አስገባ",
    "enterHere": "እዚህ ግባ",
    "enterMobile": "የሞባይል ቁጥር ያስገቡ",
    "phoneRequired": "ስልክ ያስፈልጋል",
    "phoneValid": "ስልክ የሚሰራ መሆን አለበት።",
    "unableToUpdate": "ማዘመን አልተቻለም",
    "membershipPlans": "የአባልነት ዕቅዶች",
    "byWeek": "በሳምንቱ",
    "byMonth": "በወር",
    "byYear": "በዓመት",
    "custom": "ብጁ",
    "name": "ስም",
    "warehouse": "መጋዘን",
    "regionState": "ክልል/ግዛት።",
    "provinceState": "ግዛት/ግዛት።",
    "cityTown": "መንደር / ከተማ / ከተማ",
    "membershipValidity": "የመሠረት አባልነት ትክክለኛነት",
    "extendedValidity": "የተራዘመ ትክክለኛነት",
    "exportAsCSV": "እንደ CSV ወደ ውጪ ላክ",
    "filterBy": "አጣራ በ",
    "autoCondition": "የመኪና ሁኔታዎች",
    "conditional": "ሁኔታዊ",
    "comingSoon": "በቅርብ ቀን",
    "userRole": "የተጠቃሚ ሚና",
    "additionalInformationRequired": "ተጨማሪ መረጃ ያስፈልጋል",
    "back": "ተመለስ",
    "browse": "አስስ",
    "clearAll": "ሁሉንም ያፅዱ",
    "continue": "ቀጥል",
    "description": "መግለጫ",
    "selectWeek": "ሳምንት ይምረጡ",
    "confirm": "አረጋግጥ",
    "selectMonth": "ወር ይምረጡ",
    "selectDateRange": "የቀን ክልልን ይምረጡ",
    "regionDistrict": "ክልል/አውራጃ",
    "address": "አድራሻ",
    "familyTribe": "የቤተሰብ ጎሳ",
    "website": "ድህረገፅ",
    "deactivated": "ቦዝኗል",
    "active": "ንቁ",
    "country": "ሀገር",
    "farmer": "ገበሬ",
    "commodity": "ሸቀጥ",
    "quantity": "ብዛት",
    "unit": "ክፍል",
    "price": "ዋጋ",
    "save": "አስቀምጥ",
    "stateIsReq": "ግዛት ያስፈልጋል",
    "cityIsReq": "ከተማ ያስፈልጋል",
    "addressIsReq": "አድራሻ ያስፈልጋል",
    "membershipTypeReq": "የአባልነት አይነት ያስፈልጋል",
    "extendedReasonReq": "የተራዘመ ምክንያት ያስፈልጋል",
    "numberOfDaysReq": "የቀናት ብዛት ያስፈልጋል",
    "extendedMembershipValidity": "የተራዘመ የአባልነት ትክክለኛነት",
    "set": "አዘጋጅ",
    "adminRole": "የአስተዳዳሪ ሚና",
    "typeMsg": "መልእክትህን እዚህ ተይብ",
    "manageFarmer": "ገበሬን ያስተዳድሩ",
    "manageOfflineFarmers": "ከመስመር ውጭ ገበሬዎችን ያስተዳድሩ",
    "dashboardSettings": "ዳሽቦርድ ቅንብር",
    "done": "ተከናውኗል",
    "noRecordFound": "ምንም መዝገብ አልተገኘም።",
    "farmerName": "የገበሬ ስም",
    "production": "ማምረት",
    "registered": "ተመዝግቧል",
    "downloadForReport": "ፒዲኤፍ ሪፖርት ያውርዱ",
    "downloadPdfReport": "የፒዲኤፍ ሪፖርት ያውርዱ",
    "notifications": "ማሳወቂያዎች",
    "markAllAsRead": "ሁሉም እንደተነበቡ ምልክት ያድርጉ",
    "viewNotifications": "ማሳወቂያዎችን ይመልከቱ",
    "youAreUpToDate": "ወቅታዊ ነዎት",
    "sendNotifications": "የተላኩ ማሳወቂያዎች",
    "createNotification": "ማስታወቂያ ፍጠር",
    "viewAllNotifications": "ሁሉንም ማሳወቂያዎች ይመልከቱ",
    "note": "*ማስታወሻ፡ ለቪዲዮ የሚደገፈው Mp4 ፋይል ብቻ ነው።",
    "validMemberships": "ትክክለኛ አባልነቶች",
    "memberShipPlanMessage": "እርግጠኛ ነዎት ይህን የአባልነት እቅድ መሰረዝ ይፈልጋሉ?",
    "deleteMemberShipPlan": "የአባልነት እቅድን ሰርዝ",
    "systemAutoLogout": "ስርዓቱ በ2 ደቂቃ ውስጥ በራስ-ሰር ይወጣል",
    "monday": "ሰኞ",
    "tuesday": "ማክሰኞ",
    "Wednesday": "እሮብ",
    "thursday": "ሐሙስ",
    "friday": "አርብ",
    "saturday": "ቅዳሜ",
    "sunday": "እሁድ",
    "warning": "ማስጠንቀቂያ",
    "addnewOfflineFarmer": "አዲስ ከመስመር ውጭ ገበሬ ያክሉ",
    "export": "ወደ ውጪ ላክ",
    "createNewOfflineFarmer": "አዲስ ከመስመር ውጭ ገበሬ ፍጠር",
    "offlineFarmerForByingStationOnly": "ከመስመር ውጭ ገበሬ ለግዢ ጣቢያ ብቻ (አካባቢያዊ)",
    "offlineFarmerForAllByingStations": "ከመስመር ውጭ ገበሬ ለሁሉም መግዣ ጣቢያዎች (ግሎባል)",
    "noDataAvailable": "ምንም ውሂብ የለም",
    "buyingStation": "የግዢ ጣቢያ",
    "dryMillingStation": "ደረቅ ወፍጮ ጣቢያ",
    "mergeWithExistingAccount": "ካለ መለያ ጋር አዋህድ",
    "createNewAccount": "አዲስ መለያ ይፍጠሩ",
    "mobileOrEmailRequiredForRegister": "መተግበሪያውን ለመመዝገብ ቢያንስ አንድ ዝርዝር የሞባይል ቁጥር ወይም ኢሜል መቅረብ አለበት።",
    "selectLanguage": "ቋንቋ ይምረጡ",
    "basicPlan": "መሰረታዊ እቅድ",
    "local": "አካባቢያዊ",
    "newUser": "አዲስ ተጠቃሚ",
    "merged": "ተዋህዷል",
    "global": "ዓለም አቀፍ",
    "qrcode": "QR ኮድ",
    "errors": {
        "cannotBeBlank": "ይህ መስክ ባዶ ሊሆን አይችልም።",
        "required": "ይሄ ቦታ ይፈለጋል",
        "somethingWentWrong": "የሆነ ስህተት ተከስቷል!!!"
    },
    "loadingData": "ውሂብ በመጫን ላይ...",
    "markAsRead": "እንደተነበበ ምልክት አድርግበት",
    "membership": {
        "remainingDays": "የተራዘሙ ቀናት ብዛት",
        "type": "የአባልነት አይነት",
        "validity": "የአባልነት ትክክለኛነት",
        "validityLength": {
            "custom": "ብጁ",
            "expired": "ጊዜው አልፎበታል።",
            "oneTo8Months": "ከ1-8 ወራት",
            "lessThan1Month": "ከ1 ወር በታች",
            "moreThan1Month": "ከ 1 ዓመት በላይ",
            "sixTo12Months": "6-12 ወራት"
        }
    },
    "of": "የ",
    "ok": "እሺ",
    "statusItems": {
        "closed": "ዝግ",
        "open": "ክፈት"
    },
    "orderByItems": {
        "all": "ሁሉም",
        "dateAscending": "የሚወጣበት ቀን",
        "dateDescending": "የሚወርድበት ቀን",
        "dueDate": "የመጨረሻ ማስረከቢያ ቀን",
        "high": "ከፍተኛ",
        "low": "ዝቅተኛ",
        "medium": "መካከለኛ"
    },
    "orderBy": "እዘዝ በ",
    "select": "ይምረጡ",
    "type": "ዓይነት",
    "uploadImageVideo": "ምስሎችን ይስቀሉ",
    "user": "ተጠቃሚ",
    "userName": "የተጠቃሚ ስም",
    "usersSelected": "ተጠቃሚዎች ተመርጠዋል",
    "topics": "ርዕሶች",
    "date": "ቀን",
    "addNew": "አዲስ አስገባ",
    "exportAsCsv": "እንደ CSV ወደ ውጪ ላክ",
    "noData": "ምንም ውሂብ አልተገኘም።",
    "login": {
        "welcomeMsg": "እንኳን ደህና መጣህ! ግባ",
        "info": "ምስክርነቶችዎን ያስገቡ።",
        "forgot": "መክፈቻ ቁልፉን ረሳኽው?",
        "btn": "ግባ",
        "unableToLogin": "መግባት አልተቻለም"
    },
    "forgot": {
        "info_l1": "እባክዎ ከመለያዎ ጋር የተያያዘውን የኢሜይል አድራሻ ያስገቡ። የይለፍ ቃል ዝርዝሮች ወደ ኢሜልዎ/የሞባይል አድራሻዎ ይላካሉ።",
        "info_l2": "እባክህ ከመለያህ ጋር የተያያዘውን የሞባይል ቁጥርህን አስገባ። የይለፍ ቃል ዝርዝሮች ወደ ስልክ ቁጥር ይላካሉ።",
        "info_l3": "የይለፍ ቃልዎን እንዴት እንደገና ማስጀመር እንደሚችሉ መመሪያዎችን ለመቀበል እባክዎ ከሚከተሉት አማራጮች ውስጥ አንዱን ይምረጡ",
        "forgotQ": "የሚስጥራዊውን ቁጥር ረሳህው?",
        "loginNow": "አሁን ግባ",
        "resetSucc": "የይለፍ ቃልዎ በተሳካ ሁኔታ ዳግም ተጀምሯል።",
        "resetSucc_l2": "አሁን ወደ መለያህ ለመግባት አዲሱን የይለፍ ቃልህን መጠቀም ትችላለህ።",
        "entPsw": "እባክዎ አዲሱን የይለፍ ቃልዎን ያስገቡ።",
        "resetPsw": "የይለፍ ቃልዎን ዳግም ያስጀምሩ",
        "resendOTP": "OTP እንደገና ላክ",
        "enterCorrectOTP": "እባክዎ ትክክለኛውን OTP ያስገቡ።",
        "enterOTP": "እባክዎ በኢሜል/ሞባይል የተቀበሉትን OTP ያስገቡ።",
        "backToLoginPage": "ወደ የመግቢያ ገጽ ተመለስ",
        "recieveCodeFalse": "ኮዱ አልደረሰኝም።"
    },
    "dashboard": "ዳሽቦርድ",
    "mainDashboard": "ዋና ዳሽቦርድ",
    "userDashboard": "የተጠቃሚ ዳሽቦርድ",
    "userslist": {
        "createNewUser": "አዲስ ተጠቃሚ ይፍጠሩ",
        "chooseCreateType": "እባክዎ ከሚከተሉት አማራጮች ውስጥ አንዱን ይምረጡ፡",
        "addNewUser": "አዲስ ተጠቃሚ ያክሉ",
        "editUser": "ተጠቃሚን ያርትዑ",
        "addNewAdmin": "የአስተዳዳሪ ተጠቃሚን ያክሉ",
        "userLoading": "ተጠቃሚዎችን በመጫን ላይ... እባክዎ ይጠብቁ",
        "noUser": "ምንም ተጠቃሚ አይገኝም",
        "extendVal": "ትክክለኛነትን ያራዝሙ",
        "extendReason": "የማራዘሚያ ምክንያት",
        "extendReasonMsg": "የአባልነት ማራዘሚያ ምክንያቱን ይግለጹ",
        "exportAsCSV": "እንደ CSV ላክ",
        "membershipType": "የአባልነት አይነት",
        "membershipValidity": "የአባልነት ትክክለኛነት",
        "regionState": "ክልል/ግዛት።",
        "cityTown": "ከተማ/ከተማ",
        "clearAll": "ሁሉንም ያፅዱ",
        "search": "ፈልግ",
        "familyTribe": "የቤተሰብ ጎሳዎን ያስገቡ",
        "enterWebsite": "ድር ጣቢያ ያስገቡ",
        "registrationDate": "የምዝገባ ቀን",
        "single": "ነጠላ",
        "multiple": "ብዙ",
        "user": "ተጠቃሚ"
    },
    "addEdituser": {
        "facilityPicture": "የመገልገያ ሥዕል",
        "firstNameRequired": "የመጀመሪያ ስም ያስፈልጋል",
        "firstNameOllyAlpha": "የመጀመሪያ ስም ፊደሎችን ብቻ ሊይዝ ይችላል።",
        "firstNameLimit": "የመጀመሪያ ስም ከ15 ቁምፊዎች ያነሰ መሆን አለበት።",
        "lastNameRequired": "የአያት ስም ያስፈልጋል",
        "lastNameOllyAlpha": "የአያት ስም ፊደሎችን ብቻ ሊይዝ ይችላል።",
        "lastNameLimit": "የአያት ስም ከ15 ቁምፊዎች ያነሰ መሆን አለበት።",
        "emailReuired": "ኢሜል ያስፈልጋል",
        "emailInvalid": "ልክ ያልሆነ የኢሜይል ቅርጸት።",
        "mobileRequired": "የሞባይል ቁጥር ያስፈልጋል",
        "invalidMobile": "ልክ ያልሆነ የሞባይል ቁጥር ቅርጸት።",
        "pswRequired": "የይለፍ ቃል ያስፈልጋል",
        "deptRequired": "ክፍል ያስፈልጋል",
        "roleRequired": "ሚና ያስፈልጋል",
        "countryRequired": "የአገር ኮድ ያስፈልጋል",
        "userUpdated": "ተጠቃሚ ተዘምኗል",
        "userNotUpdated": "ተጠቃሚ አልዘመነም።",
        "activateAct": "መለያን አግብር",
        "deactivateAct": "መለያን አቦዝን",
        "userActivated": "ተጠቃሚ ነቅቷል።",
        "userDeactivated": "ተጠቃሚው ቦዝኗል",
        "deactivateUser": "ተጠቃሚን አቦዝን",
        "deactivateMsg": "እርግጠኛ ነዎት የተጠቃሚውን ሁኔታ መቀየር ይፈልጋሉ።",
        "userAdded": "ተጠቃሚ ታክሏል።",
        "userNotAdded": "ተጠቃሚ አልታከለም።",
        "editAppUser": "የመተግበሪያ ተጠቃሚን ያርትዑ",
        "validityUpTo": "ትክክለኛነት እስከ"
    },
    "permissions": {
        "savePermissions": "ፈቃዶችን ያስቀምጡ",
        "moduleName": "የሞዱል ስም",
        "view": "ይመልከቱ",
        "create": "ፍጠር",
        "update": "አዘምን",
        "delete": "ሰርዝ",
        "permissionsUpdated": "ፈቃዶች ተዘምነዋል",
        "permissionsNotUpdated": "ፈቃዶች አልተዘመኑም።",
        "selectMembership": "አባልነት ይምረጡ",
        "noPermMsg": "እባክህ ፍቃዶችህን ለማየት ከላይ ያለውን &#39;የአባልነት አይነት&#39; በመጠቀም የአባልነት አይነት ምረጥ",
        "selectRoleMsg": "ፈቃዶችን ለማሳየት እባክዎ ከላይ ያለውን ሚና ይምረጡ"
    },
    "logs": {
        "time": "ጊዜ",
        "username": "የተጠቃሚ ስም",
        "role": "ሚና",
        "terminalID": "የተርሚናል መታወቂያ",
        "moduleAccessed": "ሞጁል ደርሷል",
        "typeOfAccess": "የመዳረሻ አይነት",
        "activityLogDetails": "የእንቅስቃሴ ምዝግብ ማስታወሻ ዝርዝሮች",
        "userId": "የተጠቃሚው መለያ",
        "lastLogin": "የመጨረሻው መግቢያ",
        "geoAccPoint": "ጂኦግራፊያዊ መዳረሻ ነጥብ",
        "ipAdd": "የአይፒ አድራሻ",
        "filesAccessed": "ፋይሎች ተደርሰዋል",
        "funAccessed": "ተግባር ደርሷል",
        "webUrl": "የድረ-ገጽ URL",
        "unsuccAtmp": "የመግባት ሙከራ አልተሳካም።",
        "view": "ይመልከቱ",
        "membershipType": "የአባልነት አይነት"
    },
    "profileSetting": {
        "profileAuthSettings": "የመገለጫ ማረጋገጫ ቅንብሮች",
        "changeSettings": "ቅንብሮችን ይቀይሩ",
        "loginLogoutSettings": "የመግቢያ/Logoff ቅንብሮች",
        "autoLogout": "በራስ-ሰር ዘግተህ ውጣ",
        "unsuccAtmp": "ያልተሳኩ የመግባት ሙከራዎች",
        "unsuccLoginLock": "ያልተሳካ የመግባት መቆለፊያ ጊዜ",
        "pswCrisetup": "የይለፍ ቃል መስፈርቶች ማዋቀር",
        "pswLength": "የይለፍ ቃል ርዝመት",
        "noOfUniquePsw": "የሚፈለጉ ልዩ የይለፍ ቃሎች ብዛት",
        "maxPswAge": "ከፍተኛው የይለፍ ቃል ዕድሜ",
        "AccRangeOfchars": "ተቀባይነት ያለው የቁምፊዎች ክልል",
        "upperCase": "አቢይ ሆሄ",
        "lowerCase": "ንዑስ ሆሄ",
        "numbers": "ቁጥሮች",
        "specialChars": "ልዩ ቁምፊዎች",
        "settingsUpdated": "ቅንብሮች ተዘምነዋል",
        "settingsNotUpdated": "ቅንብሮች አልተዘመኑም።",
        "organization": "ድርጅት",
        "organizationLogo": "የድርጅት አርማ",
        "organizationSplash": "የድርጅት የመክፈቻ ስክሪን",
        "cropsHarvestAlert": "የሰብል ምርት ማንቂያ",
        "alertCrop": "ሰብል",
        "alertCropInfo": "ማንቂያ የሚያገኙበትን ሰብል",
        "alertCountry": "ሀገር",
        "alertCountryInfo": "ማስጠንቀቂያ የሚያገኙበት አገር",
        "alertRegion": "ክልል",
        "alertRegionInfo": "ማስጠንቀቂያ የሚያገኙበት የተመረጠ ሀገር ክልል",
        "alertMaximum": "ከፍተኛው መጠን",
        "alertMaximumInfo": "የሚፈቀደው ከፍተኛ መጠን ከዚያ በኋላ ማሳወቂያ ይደርሰዎታል",
        "selectCrop": "ሰብልን ይምረጡ",
        "alertFor": "ማንቂያውን ማን እንደሚቀበል ይምረጡ",
        "alertAdmin": "ማንቂያ አስተዳዳሪ",
        "alertFarmer": "ማንቂያ ገበሬ",
        "selectRegion": "ክልል ይምረጡ",
        "maxProduction": "ከፍተኛ ምርት",
        "defaultOtpOrganization": "ነባሪ ድርጅት OTP ለመመዝገቢያ"
    },
    "dashboardSection": {
        "greenBeansData": "አረንጓዴ ባቄላ አስተዳደር",
        "dryMilling": "ደረቅ ወፍጮ",
        "modules": "ሞጁሎች",
        "allowances": "አበል",
        "maxUserAllowed": "ከፍተኛ ተጠቃሚዎች ተፈቅደዋል",
        "satelliteReportsAllowed": "የሳተላይት ሪፖርቶች ተፈቅደዋል",
        "advanceReport": "የላቁ ሪፖርቶች ተፈቅደዋል",
        "subscriptionUpTo": "የደንበኝነት ምዝገባ እስከ",
        "roleAllowed": "የተፈቀዱ ሚናዎች",
        "moduleAllowed": "ሞጁሎች ተፈቅደዋል",
        "registeredUsers": "የተመዘገቡ ተጠቃሚዎች",
        "validMemberships": "ትክክለኛ አባልነቶች",
        "activeUsers": "ንቁ ተጠቃሚዎች",
        "deactivatedUsers": "የቦዘኑ ተጠቃሚዎች",
        "membershipValidity": "የአባልነት ትክክለኛነት",
        "lessThan1Month": "ከ1 ወር በታች",
        "months1to6": "1-6 ወራት",
        "months6to12": "6-12 ወራት",
        "moreThan1Year": "ከ 1 ዓመት በላይ",
        "cropOverview": "አጠቃላይ እይታን ይከርክሙ",
        "plantations": "ተክሎች",
        "coffeeData": "የቡና መረጃ",
        "availableModules": "የሚገኙ ሞጁሎች",
        "roleList": "ገበሬ ፣ የግዢ ጣቢያ ፣ መጋዘን",
        "memberData": "የአባል ውሂብ",
        "userType": "የተጠቃሚ ዓይነት",
        "registered": "ተመዝግቧል",
        "offlineUsers": "ከመስመር ውጭ ተጠቃሚዎች",
        "lessThanOneMonth": "&lt; 1 ወር",
        "cacaoData": "የካካዎ ውሂብ",
        "dryCacao": "ደረቅ ካካዎ",
        "traceability": "የመከታተያ ችሎታ"
    },
    "adminRoles": {
        "adminRoles": "የአስተዳዳሪ ሚናዎች",
        "roleName": "የሚና ስም",
        "description": "መግለጫ",
        "viewPermissions": "ፈቃዶችን ይመልከቱ",
        "createAdminRole": "የአድሚን ሚና ፍጠር",
        "enterDesHere": "መግለጫህን እዚህ አስገባ",
        "deleteRole": "ሚናዎችን ሰርዝ",
        "deleteMsg": "እርግጠኛ ነዎት ሮል ማጥፋት ይፈልጋሉ?",
        "roleReq": "የሚና ስም ያስፈልጋል",
        "roleLimit": "የሚና ስም ከ15 ቁምፊዎች ያነሰ መሆን አለበት።",
        "desReq": "መግለጫ ያስፈልጋል",
        "desLimit": "መግለጫው 40 ቁምፊዎች ወይም ከዚያ ያነሰ መሆን አለበት።",
        "roleSuccess": "ሚና በተሳካ ሁኔታ ተፈጥሯል።",
        "editAdminRole": "የአስተዳዳሪ ሚናን ያርትዑ",
        "roleUpdated": "ሚና ተዘምኗል",
        "noRole": "ምንም የአስተዳዳሪ ሚናዎች አልተገኙም።",
        "noRoleMsg": "እባክዎ ከላይ ያለውን &#39;የአስተዳዳሪ ሚና ፍጠር&#39; የሚለውን ቁልፍ በመጠቀም የአስተዳዳሪ ሚና ይፍጠሩ"
    },
    "membershipplanSection": {
        "defaultPlan": "ነባሪ እቅድ",
        "planType": "የዕቅድ ዓይነት",
        "planDuration": "የእቅድ ቆይታ",
        "planFee": "የእቅድ ክፍያ",
        "satelliteReport": "የሳተላይት ዘገባ",
        "advanceReport": "የቅድሚያ ሪፖርት",
        "addMembership": "አባልነትን ጨምር",
        "addMembershipPlan": "የአባልነት እቅድ ያክሉ",
        "editMembershipPlan": "የአባልነት እቅድን ያርትዑ",
        "accessSetelite": "የሳተላይት ሪፖርቶች መዳረሻ (የ 5 ሪፖርቶች ስብስብ)",
        "accessAdvanceReport": "የላቁ ሪፖርቶች መዳረሻ",
        "memPlanReq": "የአባልነት እቅድ ያስፈልጋል",
        "memPlanReqLimit": "የአባልነት እቅድ ከ20 ቁምፊዎች ያነሰ መሆን አለበት።",
        "SatelliteReq": "የሳተላይት ሪፖርት ያስፈልጋል",
        "advancedReportReq": "የላቀ ሪፖርት ያስፈልጋል",
        "durationReq": "የአባልነት ቆይታ ያስፈልጋል",
        "feeReq": "የአባልነት ክፍያ ያስፈልጋል",
        "cantLesThenZero": "ከ0 በታች መሆን አይችልም።",
        "roleReq": "የተጠቃሚ ሚና ያስፈልጋል"
    },
    "tickets": {
        "actions": {
            "create": "ቲኬት ይፍጠሩ",
            "delete": "ቲኬት ሰርዝ",
            "edit": "ቲኬት አርትዕ"
        },
        "areaOfRequest": "የጥያቄ አካባቢ",
        "assignee": "ተመዳቢ",
        "deleteTicket": {
            "confirmation": "እርግጠኛ ነህ የ{0} ቲኬት መሰረዝ ትፈልጋለህ?"
        },
        "dueDate": "የመጨረሻ ማስረከቢያ ቀን",
        "filters": {
            "ticketFor": "ትኬት ለ"
        },
        "form": {
            "ticketType": {
                "admin": "ለዲሚትራ አስተዳዳሪ ትኬት ይፍጠሩ",
                "user": "ለመተግበሪያ ተጠቃሚ ትኬት ይፍጠሩ"
            }
        },
        "markAsRead": "እንደተነበበ ምልክት አድርግበት",
        "messages": {
            "created": {
                "success": "ቲኬት በተሳካ ሁኔታ ተፈጥሯል።"
            },
            "deleted": {
                "success": "ቲኬት በተሳካ ሁኔታ ተሰርዟል።"
            }
        },
        "noData": "ምንም ቲኬቶች አልተገኙም!",
        "noDataHelpText": "እስካሁን ለእርስዎ{0}የተመደቡ ቲኬቶች የሉዎትም።{1}ለመጀመር በዚህ ስክሪን ላይ ያለውን የ\"ትኬት ፍጠር\" ቁልፍን ጠቅ ያድርጉ።",
        "pickerInMenu": "በምናሌ ውስጥ መራጭ",
        "priority": {
            "high": "ከፍተኛ",
            "label": "ቅድሚያ"
        },
        "reply": "መልስ",
        "requestedDateTime": "የተጠየቀው ቀን እና ሰዓት",
        "requestorDetails": "ጠያቂ ዝርዝሮች",
        "requestorEmail": "ጠያቂ ኢሜል",
        "subject": "ርዕሰ ጉዳይ",
        "ticketsForItems": {
            "all": "ሁሉም",
            "dimitraAdmin": "ዲሚትራ አስተዳዳሪ",
            "multipleUsers": "በርካታ ተጠቃሚዎች",
            "singleUser": "ነጠላ ተጠቃሚ"
        },
        "title": "ቲኬቶች"
    },
    "memberDataSection": {
        "import": "አስመጣ",
        "buyingStation": "የግዢ ጣቢያ",
        "continue": "ቀጥል",
        "farmerId": "የገበሬ መታወቂያ",
        "farmerName": "የገበሬ ስም",
        "farmerAddress": "የገበሬ አድራሻ",
        "quality": "ጥራት",
        "quantity": "ብዛት",
        "importAll": "ሁሉንም አስመጣ",
        "importSelected": "ማስመጣት ተመርጧል",
        "fileLoaded": "ፋይል በተሳካ ሁኔታ ተጭኗል",
        "incorrectHeaders": "ትክክል ያልሆኑ ራስጌዎች",
        "processingBatch": "የማቀነባበሪያ ባች",
        "purchaseOrder": "ትእዛዝዎን ይግዙ",
        "buyingStationDetails": "የግዥ ጣቢያ ዝርዝሮች",
        "buyingStationUsers": "የግዥ ጣቢያ ተጠቃሚዎች",
        "activityLog": "የእንቅስቃሴ ምዝገባ",
        "startDate": "የመጀመሪያ ቀን",
        "endDate": "የመጨረሻ ቀን",
        "purchasingOrder": "የግዢ ትዕዛዝ",
        "totalCoffeeCherry": "ጠቅላላ የቡና ቼሪ",
        "airHumidity": "የአየር እርጥበት",
        "density": "ጥግግት",
        "temperature": "የሙቀት መጠን",
        "beanMoistureContent": "የባቄላ እርጥበት ይዘት",
        "processType": "የሂደቱ አይነት",
        "batchRating": "የባች ደረጃን ይምረጡ",
        "purchaseDate": "የተገዛበት ቀን",
        "selectFarmer": "ገበሬን ይምረጡ",
        "selectFarm": "እርሻን ይምረጡ",
        "selectPlantation": "መትከልን ይምረጡ",
        "coffeeVariety": "የቡና ዝርያ",
        "coffeeSpecies": "የቡና ዝርያዎች",
        "coffeeCherryQuantity": "የቡና ቼሪ ብዛት",
        "coffeeCherryQuality": "የቡና ቼሪ ጥራት",
        "coffeeType": "የቡና ዓይነት",
        "pricePerKg": "ዋጋ በኪ.ግ",
        "processingDone": "ሂደት ተከናውኗል",
        "processedCoffeeOut": "የተቀነባበረ ቡና ወደ ውጭ",
        "farmer": "ገበሬ",
        "farm": "እርሻ",
        "plantation": "መትከል",
        "farmers": "ገበሬዎች",
        "farmLimitUsed": "ጥቅም ላይ የዋለው የእርሻ ገደብ",
        "phoneNumber": "ስልክ ቁጥር",
        "farmSize": "የእርሻ መጠን",
        "farmLocation": "እርሻ/ቦታ",
        "date": "ቀን",
        "status": "ሁኔታ",
        "noFarmers": "ገበሬዎች አልተገኙም።",
        "approveReject": "አጽድቅ/አትቀበል",
        "farms": "እርሻዎች",
        "crops": "ሰብሎች",
        "equipment": "መሳሪያዎች",
        "noFarms": "ምንም እርሻዎች አልተገኙም።",
        "views": "ይመልከቱ",
        "selectStatus": "ሁኔታን ይምረጡ",
        "approved": "ጸድቋል",
        "rejected": "ውድቅ ተደርጓል",
        "reject": "እምቢ",
        "approve": "አጽድቅ",
        "cancel": "ሰርዝ",
        "add": "አክል",
        "describeYourReason": "ምክንያትህን እዚህ ግለጽ",
        "userInformation": "የተጠቃሚ መረጃ",
        "userFarmRequest": "የተጠቃሚ እርሻ ጥያቄ",
        "userFarmInformation": "የተጠቃሚ እርሻ(ዎች) መረጃ",
        "activity": "እንቅስቃሴ",
        "activityType": "የእንቅስቃሴ አይነት",
        "farmZone": "የእርሻ ዞን",
        "farmerView": "የገበሬ እይታ",
        "cropType": "የሰብል ዓይነት",
        "cropVarity": "የሰብል ልዩነት",
        "area": "አካባቢ",
        "cost": "ወጪ",
        "geofence": "ጂኦፊንስ",
        "map_views": "የካርታ እይታ",
        "viewAllFarms": "ሁሉንም እርሻዎች ይመልከቱ",
        "farmersDetails": "የገበሬ ዝርዝሮች",
        "download": "አውርድ",
        "pOrder": {
            "addNew": "አዲስ አስገባ",
            "viewAll": "ሁሉንም ይመልከቱ",
            "selectDate": "ቀን ይምረጡ",
            "makeSelection": "ምርጫ ያድርጉ",
            "coffeeType": "የቡና መጠን ይተይቡ",
            "enterPrice": "ዋጋ ያስገቡ",
            "reqPurchaseDate": "የግዢ ቀን ያስፈልጋል",
            "reqFarmer": "ገበሬ ያስፈልጋል",
            "reqCoffeeQnty": "የቡና ቼሪ ብዛት ያስፈልጋል",
            "reqPrice": "ዋጋ በኪሎ ያስፈልጋል",
            "grandTotal": "አጠቃላይ ድምር",
            "selectDateRange": "የቀን ክልልን ይምረጡ",
            "import": "አስመጣ",
            "purchaseId": "የግዢ መታወቂያ",
            "purchaseDate": "የተገዛበት ቀን",
            "farmerName": "የገበሬ ስም",
            "quality": "ጥራት",
            "quantity": "ብዛት",
            "pricePerKg": "ዋጋ በኪ.ግ",
            "selectBuyingStation": "የግዢ ጣቢያ ይምረጡ",
            "searchUser": "ተጠቃሚዎችን ይፈልጉ"
        }
    },
    "roleRequest": {
        "roleRequest": "የሚና ጥያቄ",
        "userRole": "የተጠቃሚ ሚና",
        "approve": "አጽድቅ",
        "reject": "እምቢ",
        "username": "የተጠቃሚ ስም",
        "email": "ኢሜይል",
        "phone": "ስልክ",
        "roleAssigned": "የተመደበው ሚና",
        "roleRequested": "ሚና ተጠይቋል",
        "requestedDate": "የተጠየቀበት ቀን",
        "updateRoleRequest": "የሚና ጥያቄን ያዘምኑ",
        "message": "መልእክት",
        "update": "አዘምን"
    },
    "faqSection": {
        "createFaq": "የሚጠየቁ ጥያቄዎችን ፍጠር",
        "createTopic": "ርዕስ ፍጠር",
        "selectTopic": "ርዕስ ይምረጡ",
        "faqQuestion": "የሚጠየቁ ጥያቄዎች",
        "faqAnswer": "የሚጠየቁ ጥያቄዎች መልስ",
        "uploadImgVid": "ምስል/ቪዲዮ ስቀል",
        "disInFaq": "በ FAQ ክፍል ውስጥ አሳይ",
        "editFaq": "የሚጠየቁ ጥያቄዎች አርትዕ",
        "topicName": "ርዕስ ስም",
        "parentTopic": "የወላጅ ርዕስ",
        "editTopic": "ርዕስ አርትዕ",
        "createSection": "እባክዎ መጀመሪያ ክፍል ይፍጠሩ",
        "createTopicFirst": "እባክዎ መጀመሪያ ርዕስ ይፍጠሩ",
        "questionReq": "የሚጠየቁ ጥያቄዎች ጥያቄ ያስፈልጋል",
        "answerReq": "የሚጠየቁ ጥያቄዎች መልስ ያስፈልጋል"
    },
    "reports": {
        "gen": "ጾታ",
        "gender": "የሥርዓተ-ፆታ ሰንጠረዥ",
        "male": "ወንድ",
        "female": "ሴት",
        "non_binary": "ሁለትዮሽ ያልሆነ",
        "avgPriceFarmer": "በገበሬ (ካካዎ) የሚከፈል አማካይ ዋጋ",
        "avgPrice": "አማካይ ዋጋ",
        "total": "ጠቅላላ",
        "farmerName": "የገበሬ ስም",
        "farmerProdChart": "የገበሬ ምርት ገበታ",
        "production": "ማምረት",
        "byProduction": "በፕሮዳክሽን",
        "byName": "በስም",
        "descending": "መውረድ",
        "ascending": "ወደ ላይ መውጣት",
        "buyingStationProdChart": "የግዢ ጣቢያ ምርት ገበታ",
        "buyingStation": "የግዢ ጣቢያ",
        "buyingStationName": "የግዢ ጣቢያ ስም",
        "dryMilling": "ደረቅ ወፍጮ",
        "dryMillingName": "ደረቅ ወፍጮ ስም",
        "dryMillingProdChart": "የደረቅ ወፍጮ ምርት ገበታ",
        "view": "ይመልከቱ",
        "date": "ቀን",
        "reports": "ሪፖርቶች",
        "today": "ዛሬ",
        "week": "ሳምንት",
        "month": "ወር",
        "year": "አመት",
        "all": "ሁሉም",
        "selectCrop": "ሰብልን ይምረጡ",
        "selectRegion": "ክልል ይምረጡ",
        "downloadPdfReport": "የፒዲኤፍ ሪፖርት ያውርዱ",
        "export": "ወደ ውጪ ላክ",
        "search": "ፈልግ",
        "yield": "ምርት",
        "pests": {
            "pestReport": "የተባይ ሪፖርት",
            "filterByCrops": "በሰብል አጣራ",
            "pestStatistics": "የተባይ ስታቲስቲክስ",
            "regions": "ክልሎች",
            "occurrences": "ክስተቶች",
            "pestChart": "የተባይ ገበታ",
            "totalArea": "ጠቅላላ አካባቢ",
            "pestName": "የተባይ ስም",
            "region": "ክልል",
            "crop": "ሰብሎች",
            "listByLand": "ዝርዝር በመሬት"
        },
        "regions": {
            "regionalReport": "የክልል ሪፖርት",
            "listByFarm": "ዝርዝር በእርሻ",
            "listByFarmers": "በገበሬዎች ዝርዝር",
            "listByYield": "ዝርዝር በምርት።",
            "regionalStatistics": "የክልል ስታቲስቲክስ",
            "countries": "አገሮች",
            "states": "ክልሎች/አውራጃዎች",
            "city": "ከተማ / ከተማ / መንደር",
            "farmsIn": "እርሻዎች በ",
            "regionalChart": "የክልል ገበታ",
            "farms": "እርሻዎች",
            "regionName": "የክልል ስም",
            "farmers": "ገበሬዎች",
            "yield": "ምርት/ኤከር"
        },
        "dashboard": {
            "topCharts": "ከፍተኛ ገበታዎች",
            "regions": "ክልሎች",
            "noOfFarms": "የእርሻ / ክልል ቁጥር",
            "provinces": "ክልሎች ግዛቶች",
            "landArea": "የመሬት ስፋት",
            "avgFarmerLand": "አማካኝ የገበሬ መሬት",
            "viewAll": "ሁሉንም ይመልከቱ",
            "crops": "ሰብሎች",
            "plantedAreaCrop": "የተከለ ቦታ/ሰብል",
            "plantedArea": "የተተከለው አካባቢ",
            "avgYieldCrop": "አማካኝ ምርት/ሰብል",
            "averageYield": "አማካይ ትርፍ",
            "yieldChart": "የምርት ገበታ",
            "selectFarm": "እርሻን ይምረጡ",
            "soilQuality": "የአፈር ጥራት",
            "pests": "ተባዮች",
            "occurrences": "ክስተቶች",
            "equipments": "መሳሪያዎች",
            "goalAchievedChart": "የተሳኩ ግቦች ገበታ",
            "soilValues": "የአፈር እሴቶች",
            "soil": "አፈር",
            "showReport": "በዳሽቦርድ ላይ ሪፖርቶችን አሳይ",
            "selectAll": "ሁሉንም ምረጥ"
        }
    },
    "traceability": {
        "traceability": "የመከታተያ ችሎታ",
        "coffeeTraceabilityMngmnt": "የቡና መከታተያ አስተዳደር",
        "traceabilityPage": "የመከታተያ ገጽ",
        "labelDesigner": "መለያ ንድፍ አውጪ",
        "additionalInformation": "ተጭማሪ መረጃ",
        "info1": "ስለምርትዎ ተጨማሪ አርማዎች መረጃ ያቅርቡ። ይህ መረጃ በቡና መፈለጊያ ገጽ ላይ ለህዝብ ይቀርባል።",
        "addSlogan": "መፈክር ያክሉ",
        "sloganToolTip": "ወደ ምርትዎ መፈክር ያክሉ። ይህ መረጃ በክትትል ገጹ ላይ ለህዝብ ይቀርባል።",
        "additionalLogos": "ተጨማሪ ሎጎዎች",
        "title": "ርዕስ",
        "description": "መግለጫ",
        "mapLink": "የካርታ አገናኝ",
        "websiteLink": "የድር ጣቢያ አገናኝ",
        "addMedia": "ሚዲያ አክል",
        "uploadImageVideo": "ምስል/ቪዲዮ ስቀል",
        "uploadImage": "ምስል ስቀል",
        "origin": "መነሻ",
        "info2": "ስለምርትዎ መነሻ ሀገር መረጃ ያቅርቡ። ይህ መረጃ በቡና መፈለጊያ ገጽ ላይ ለህዝብ ይቀርባል።",
        "countryImage": "የሀገር ምስል",
        "traceabilityImage": "የመከታተያ ምስል",
        "institutionalInfo": "ተቋማዊ መረጃ",
        "info3": "ስለ ኩባንያዎ/የኅብረት ሥራዎ መረጃ ያቅርቡ፣ ሲያደርጉት የነበረውን ተዛማጅ ሥራ ለተጠቃሚዎች ይንገሩ። ይህ መረጃ በቡና መፈለጊያ ገጽ ላይ ለህዝብ ይቀርባል.",
        "cooperativeLogo": "የትብብር አርማ",
        "traceabilityIntro": "የመከታተያ ችሎታ መግቢያ",
        "info4": "ይህ ክፍል ለተጠቃሚው አጠቃላይ የቡና አመራረት እና አቀነባበር ታሪክ መዳረሻ ይሰጣል። የመከታተያ አስፈላጊነት ለድርጅትዎ/የህብረት ስራዎ እና ለአለም ያብራሩ።",
        "addLabel": "መለያ ያክሉ",
        "chooseTitle": "ርዕስ ይምረጡ",
        "chooseLabelDesign": "የመለያ ንድፍ አብነት ይምረጡ",
        "uploadYourLogo": "አርማህን ስቀል",
        "info5": "መመሪያዎች፡ የምስል መጠን ቢያንስ 1000 x 1000 ፒክስል ካሬ መሆን አለበት። ከበስተጀርባ ቀለሞች ጋር ለማመሳሰል ግልጽ PNG መምረጥ ይችላሉ።",
        "chooseTemplateColors": "የአብነት ቀለሞችን ይምረጡ",
        "backgroundColor": "የበስተጀርባ ቀለም",
        "foregroundColor": "የፊት ለፊት ቀለም",
        "labelStatus": "መለያ ሁኔታ",
        "inactive": "እንቅስቃሴ-አልባ",
        "download": "አውርድ",
        "enterLabelTitle": "የመለያ ርዕስ አስገባ"
    },
    "cacaoTraceability": {
        "traceability": "የመከታተያ ችሎታ",
        "cacaoTraceabilityMngmnt": "የካካዎ ተከታታይነት አስተዳደር",
        "traceabilityPage": "የመከታተያ ገጽ",
        "labelDesigner": "መለያ ንድፍ አውጪ",
        "additionalInformation": "ተጭማሪ መረጃ",
        "info1": "ስለምርትዎ ተጨማሪ አርማዎች መረጃ ያቅርቡ። ይህ መረጃ በካካዎ መከታተያ ገጽ ላይ ለህዝብ ይቀርባል።",
        "addSlogan": "መፈክር ያክሉ",
        "additionalLogos": "ተጨማሪ ሎጎዎች",
        "title": "ርዕስ",
        "description": "መግለጫ",
        "mapLink": "የካርታ አገናኝ",
        "websiteLink": "የድር ጣቢያ አገናኝ",
        "addMedia": "ሚዲያ አክል",
        "uploadImageVideo": "ምስል/ቪዲዮ ስቀል",
        "origin": "መነሻ",
        "info2": "ስለምርትዎ መነሻ ሀገር መረጃ ያቅርቡ። ይህ መረጃ በካካዎ መከታተያ ገጽ ላይ ለህዝብ ይቀርባል።",
        "countryImage": "የሀገር ምስል",
        "institutionalInfo": "ተቋማዊ መረጃ",
        "info3": "ስለ ኩባንያዎ/የኅብረት ሥራዎ መረጃ ያቅርቡ፣ ሲያደርጉት የነበረውን ተዛማጅ ሥራ ለተጠቃሚዎች ይንገሩ። ይህ መረጃ በካካዎ መከታተያ ገጽ ላይ ለህዝብ ይቀርባል።",
        "cooperativeLogo": "የትብብር አርማ",
        "traceabilityIntro": "የመከታተያ ችሎታ መግቢያ",
        "info4": "ይህ ክፍል ለተጠቃሚው አጠቃላይ የቡና አመራረት እና አቀነባበር ታሪክ መዳረሻ ይሰጣል። የመከታተያ አስፈላጊነት ለድርጅትዎ/የህብረት ስራዎ እና ለአለም ያብራሩ።",
        "addLabel": "መለያ ያክሉ",
        "chooseTitle": "ርዕስ ይምረጡ",
        "chooseLabelDesign": "የመለያ ንድፍ አብነት ይምረጡ",
        "uploadYourLogo": "አርማህን ስቀል",
        "info5": "መመሪያዎች፡ የምስል መጠን ቢያንስ 1000 x 1000 ፒክስል ካሬ መሆን አለበት። ከበስተጀርባ ቀለሞች ጋር ለማመሳሰል ግልጽ PNG መምረጥ ይችላሉ።",
        "chooseTemplateColors": "የአብነት ቀለሞችን ይምረጡ",
        "backgroundColor": "የበስተጀርባ ቀለም",
        "foregroundColor": "የፊት ለፊት ቀለም",
        "labelStatus": "መለያ ሁኔታ",
        "inactive": "እንቅስቃሴ-አልባ",
        "download": "አውርድ",
        "enterLabelTitle": "የመለያ ርዕስ አስገባ"
    },
    "setting": {
        "profileAuthSetting": "የመገለጫ ማረጋገጫ ቅንብሮች",
        "logInOutSetting": "የመግቢያ/የመውጣት ቅንብሮች",
        "autoLogout": "ራስ-ውጣ",
        "unsuccessfulLoginAttempt": "ያልተሳኩ የመግባት ሙከራዎች",
        "unsuccessfulLoginLockPeriod": "ያልተሳካ የመግባት መቆለፊያ ጊዜ",
        "passCriteriaSetup": "የይለፍ ቃል መስፈርቶች ማዋቀር",
        "passLength": "የይለፍ ቃል ርዝመት",
        "noUniquePassRequired": "የሚፈለጉ ልዩ የይለፍ ቃሎች ብዛት",
        "maxPassAge": "ከፍተኛው የይለፍ ቃል ዕድሜ",
        "acceptableRangeOfChars": "ተቀባይነት ያለው የቁምፊዎች ክልል",
        "upperCase": "የላይኛው መያዣ",
        "lowerCase": "ንዑስ ሆሄ",
        "numbers": "ቁጥሮች",
        "specialChars": "ልዩ ቁምፊዎች",
        "uniqueSymbols": "ልዩ ምልክቶች",
        "loadingData": "ውሂብ በመጫን ላይ...",
        "currency": "ምንዛሪ",
        "codeActivationTime": "ኮድ ገቢር ጊዜ",
        "changeGlobalSetting": "ዓለም አቀፍ ቅንብሮችን ይቀይሩ",
        "globalSetting": "ዓለም አቀፍ ቅንብሮች",
        "generalSetting": "አጠቃላይ ቅንብሮች",
        "hour": "ሰዓታት",
        "days": "ቀናት",
        "minutes": "ደቂቃዎች",
        "perDay": "በቀን",
        "perHour": "በ ሰዓት",
        "customised": "ብጁ የተደረገ",
        "areaUnit": "የአካባቢ ክፍል",
        "weightUnit": "የክብደት ክፍል",
        smallFarm: "ትንሽ እርሻ",
        inclusive: "አብራሪ",
        from: "ከ",
        to: "እስከ",
        mediumFarm: "መካከለኛ እርሻ",
        largeFarm: "ትልቅ እርሻ",
        requiredMessage: "ይህ መስክ አስፈላጊ ነው",
        nonNegativeMessage: "ይህ መስክ ኑሮት ሊሆን አይችልም",
        fieldToGreaterThanFrom: "ይህ መስክ ከ 'ከ' መስክ በላይ ሊሆን አለበት",
        fieldToGreaterThanFromMedium: "ይህ መስክ ከትንሽ እርሻ 'እስከ' መስክ በላይ ሊሆን አለበት",
        fieldToGreaterThanMediumTo: "ይህ መስክ ከመካከለኛ እርሻ 'እስከ' መስክ በላይ ሊሆን አለበት",
    },
    "coffeeData": {
        "windBreaker": "የንፋስ መከላከያ ዛፍ",
        "horticultureInfo": "የአትክልት ዛፍ",
        "shadeTree": "የጥላ ዛፍ",
        "coffeeVariety": "የቡና ዝርያ",
        "coffeeSpecies": "የቡና ዝርያዎች",
        "updateWindBreaker": "የንፋስ ሰባሪ የዛፍ አይነትን ያዘምኑ",
        "addWindBreaker": "አዲስ የንፋስ መከላከያ ዛፍ ዓይነት ይጨምሩ",
        "updateHorticultureInfo": "የሆርቲካልቸር መረጃን የዛፍ አይነት ያዘምኑ",
        "addHorticultureInfo": "አዲስ የሆርቲካልቸር መረጃ የዛፍ ዓይነት ያክሉ",
        "updateShadeTree": "የጥላ ዛፍ ዓይነትን ያዘምኑ",
        "addShadeTree": "አዲስ የጥላ ዛፍ ዓይነት ይጨምሩ",
        "updateCoffeeVariety": "የቡና ዝርያን ያዘምኑ የዛፍ ዓይነት",
        "addCoffeeVariety": "አዲስ የቡና ዝርያ ያክሉ የዛፍ ዓይነት",
        "deleteVarietyTitle": "ልዩነትን ሰርዝ",
        "deleteVarietyMessage": "እርግጠኛ ነህ ቫሪቲን መሰረዝ ትፈልጋለህ?",
        "updateCoffeeSpecie": "የቡና ዝርያን አዘምን",
        "deleteSpecieTitle": "Specie ሰርዝ",
        "deleteSpecieMessage": "እርግጠኛ ነዎት Specieን መሰረዝ ይፈልጋሉ?",
        "addCoffeeSpecie": "አዲስ የቡና ዓይነት ይጨምሩ",
        "variety": "ልዩነት",
        "selectVariety": "Specie ይምረጡ",
        "deleteCoffeeRecord": "እርግጠኛ ነህ መዝገብ መሰረዝ ትፈልጋለህ?",
        "deleteCoffeeData": "የቡና ውሂብን ሰርዝ",
        "topicRequired": "ርዕስ ምረጥ ያስፈልጋል",
        "coffeeAddSuccess": "የቡና ዝርያ በተሳካ ሁኔታ ታክሏል።",
        "treeTypeSuccess": "የዛፍ ዓይነት በተሳካ ሁኔታ ተጨምሯል።",
        "treeTypeUpdateSuccess": "የዛፍ አይነት በተሳካ ሁኔታ ዘምኗል።",
        "coffeeVarietySuccess": "የቡና ዝርያ በተሳካ ሁኔታ ተጨምሯል.",
        "coffeeSpecieSuccess": "የቡና ዝርያ በተሳካ ሁኔታ ዘምኗል።",
        "nameRequired": "ስም ያስፈልጋል",
        "notFound": "ምንም የአስተዳዳሪ ቡና ውሂብ አልተገኘም።"
    },
    "cacaoData": {
        "cacao": "ካካዎ",
        "cacaoOverview": "የካካዎ አጠቃላይ እይታ",
        "cacaoVariety": "የካካዎ ልዩነት",
        "cacaoSpecies": "የካካዎ ዝርያዎች",
        "deleteCacaoData": "የካካኦ ውሂብን ሰርዝ"
    },
    "plantation": {
        "farmerName": "የገበሬ ስም",
        "phoneNumber": "ስልክ ቁጥር",
        "plantationName": "የእፅዋት ስም",
        "farm": "እርሻ",
        "location": "አካባቢ",
        "updatePlantationStatus": "የእፅዋት ሁኔታን ያዘምኑ",
        "update": "አዘምን"
    },
    "activationKey": {
        "enterActivationKey": "እባክዎ አዲስ ተጠቃሚን ለመመዝገብ የማግበር ቁልፍ ያስገቡ",
        "countryRequired": "ሀገር ያስፈልጋል",
        "activationKeyRequired": "የማግበር ቁልፍ ያስፈልጋል",
        "activationKey": "የማግበር ቁልፍ",
        "activationKeyLimit": "የማግበሪያ ቁልፍ በጣም አጭር",
        "membershipRoleFilterDesc": "የአባልነት እቅድን በሚና አጣራ",
        "email": "ኢሜይል",
        "filterBy": "አጣራ በ",
        "membershipRoleFilter": "የአባልነት ሚና ማጣሪያ",
        "appointSalesManager": "የሽያጭ አስተዳዳሪን ይሾሙ",
        "appointManager": "አስተዳዳሪን ይሾሙ",
        "salesManAppSuccess": "የሽያጭ አስተዳዳሪ በተሳካ ሁኔታ ተሾመ",
        "uploadData": "የተመደበ ውሂብ CSV ይስቀሉ",
        "uploadUserData": "እባክዎ የተጠቃሚውን ውሂብ ፋይል ይስቀሉ።",
        "downloadCsv": "አወቃቀሩን ለመከተል የናሙናውን .csv ፋይል ያውርዱ",
        "downloadSample": "የናሙና ፋይል ያውርዱ",
        "dragDrop": "ጎትት እና ጣል ወይም",
        "browse": "ማሰስ",
        "yourFile": "የእርስዎን ፋይል",
        "incorectFileType": "የተሳሳተ የፋይል አይነት",
        "somethingWentWrong": "የሆነ ስህተት ተከስቷል",
        "fileUploadedSuccess": "ፋይል በተሳካ ሁኔታ ተጭኗል",
        "countRecords": "መዝገቦችን ይቁጠሩ",
        "sendNow": "አሁን ላኪ",
        "fileName": "የመዝገብ ስም",
        "assignActKey": "የማግበር ቁልፎችን መመደብ",
        "actKeyAssSucc": "የማግበሪያ ቁልፎች በተሳካ ሁኔታ ተመድበዋል።",
        "viewActKey": "የማግበር ቁልፎችን ይመልከቱ",
        "actKeyQuota": "የማግበር ቁልፎች ኮታ",
        "genActKey": "የመነጩ የማግበሪያ ቁልፎች",
        "remActKey": "ቀሪ የማግበሪያ ቁልፎች",
        "penUsed": "በመጠባበቅ ላይ ያሉ እና ያገለገሉ ቁልፎች",
        "activationKeyAss": "የማግበሪያ ቁልፎች ተመድበዋል።",
        "activationKeyUnass": "የማግበር ቁልፎች አልተመደቡም።",
        "keysAct": "ቁልፎች ነቅተዋል።",
        "uploadedFiles": "የተጫኑ ፋይሎች",
        "generateActKey": "የማግበር ቁልፎችን ፍጠር",
        "showData": "ውሂብ አሳይ",
        "noDataFound": "ምንም ቀን አልተገኘም።",
        "pleaseGenKey": "እባኮትን የማግበሪያ ቁልፎቹን \"የማግበሪያ ቁልፎችን ፍጠር\" የሚለውን ተጠቅመው ይፍጠሩ",
        "noActKey": "እስካሁን ምንም የማግበር ቁልፎች አልተፈጠሩም።",
        "buttonAbv": "አዝራር ከላይ",
        "numberOfActKey": "የማግበር ቁልፎች ብዛት",
        "membershipRole": "የአባልነት ሚና",
        "membershipPlan": "የአባልነት እቅድ",
        "comments": "አስተያየቶች",
        "genKeys": "ቁልፎችን አመንጭ",
        "keysNum": "ቁልፎች ቁጥር",
        "phoneNumber": "ስልክ ቁጥር",
        "keysStatus": "የቁልፍ ሁኔታ",
        "ActivationKeysList": "የማግበሪያ ቁልፎች ዝርዝር",
        "back": "ተመለስ",
        "usingActKeys": "\"የማግበሪያ ቁልፎችን ፍጠር\" የሚለውን በመጠቀም",
        "pleaseGenActKeyss": "እባክዎ የማግበሪያ ቁልፉን ያመነጩ",
        "clearAllFilters": "ሁሉንም ማጣሪያዎች ያጽዱ",
        "salesManager": "የሽያጭ ሃላፊ",
        "clearAll": "ሁሉንም ያፅዱ",
        "generatedBy": "የተፈጠረ በ",
        "numberOfKeys": "የቁልፎች ብዛት",
        "action": "ድርጊት",
        "viewAllUplFiles": "ሁሉንም የተጫኑ ፋይሎችን ይመልከቱ",
        "bulkUploadUsers": "የጅምላ ሰቀላ ተጠቃሚዎች",
        "noActivationKeyFound": "ምንም የማግበር ቁልፎች አልተገኙም።",
        "pleaseCreateAdminRole": "እባክዎን በመጠቀም የአስተዳዳሪ ሚና ይፍጠሩ",
        "btnCreateAdmin": "አዝራር ከላይ &#39;የአስተዳዳሪ ሚና ፍጠር&#39;",
        "donwloadAsCsv": "እንደ CSV አውርድ",
        "donwloadAsPdf": "እንደ PDF አውርድ",
        "assignSalesManager": "የሽያጭ አስተዳዳሪን መድብ",
        "shareViaEmail": "በኢሜል አጋራ",
        "sendEmail": "ኢሜል ላክ",
        "emailSend": "ኢሜል በተሳካ ሁኔታ ተልኳል።",
        "donwload": "አውርድ",
        "deleteFile": "ፋይል ሰርዝ",
        "invalidFileData": "በፋይል ላይ የማግበር ቁልፍ ውሂብ ልክ ያልሆነ ነው።"
    },
    "surveyBuilder": {
        "clearSelection": "ሁሉንም ተጠቃሚዎች አጽዳ",
        "addNewSurvey": "አዲስ የዳሰሳ ጥናት ያክሉ",
        "surveyTitle": "የዳሰሳ ጥናት ርዕስ",
        "surveyName": "የዳሰሳ ስም",
        "surveyDescription": "የዳሰሳ ጥናት መግለጫ",
        "describeSurvey": "ዳሰሳውን ይግለጹ",
        "enableScheduling": "መርሐግብር ማስያዝን አንቃ",
        "selectedDate": "የተመረጠው ቀን",
        "multiStepSurvey": "ባለብዙ ደረጃ ዳሰሳ",
        "multiStepSurveyDetails": "በደረጃ የጥያቄዎች ብዛት ላይ በመመስረት፣ በዳሰሳ ጥናቱ ውስጥ ያሉ ሁሉም ጥያቄዎች በቡድን ሆነው በደረጃ ይታያሉ።",
        "multiStep": "ባለብዙ ደረጃ",
        "noQuestionEachStep": "በእያንዳንዱ ደረጃ የጥያቄዎች ብዛት",
        "surveyStatus": "የዳሰሳ ጥናት ሁኔታ",
        "surveyStatusDetails": "የዳሰሳ ጥናት ማንቃት የሚቻለው ጥያቄዎችን ካከሉ በኋላ ነው። የዳሰሳ ጥናትን ማንቃት ገበሬዎች ማቅረብ እንዲጀምሩ ያስችላቸዋል።",
        "selectUsers": "ተጠቃሚዎችን ይምረጡ",
        "selectUsersDetails": "የተመረጠ ተጠቃሚ ከተሰናከለ የዳሰሳ ጥናቱ ለሁሉም ተጠቃሚዎች ይገኛል። የተመረጡ ተጠቃሚዎችን ካነቁ በሚቀጥለው ደረጃ ብዙ ተጠቃሚዎችን መምረጥ ይችላሉ።",
        "linkWithFarms": "ከእርሻዎች ጋር አገናኝ",
        "linkWithFarmsDetails": "የዳሰሳ ጥናቱ ከነቃ ከእያንዳንዱ እርሻ ጋር ይያያዛል። አንድ ገበሬ ብዙ እርሻዎች ካሉት እያንዳንዱ እርሻ የራሱ የዳሰሳ ጥናት ይኖረዋል።",
        "enabled": "ነቅቷል",
        "disabled": "ተሰናክሏል።",
        "cancel": "ሰርዝ",
        "next": "ቀጥሎ",
        "surveySettings": "የዳሰሳ ቅንብሮች",
        "selectSurveyUsers": "የዳሰሳ ተጠቃሚዎችን ይምረጡ",
        "selectToProceed": "እባክዎ ለመቀጠል ተጠቃሚ(ዎችን) ይምረጡ",
        "searchUsers": "ተጠቃሚዎችን ይፈልጉ",
        "usersSelected": "ተጠቃሚዎች ተመርጠዋል",
        "conditional": "ሁኔታዊ",
        "autoConditional": "አውቶማቲክ ሁኔታዊ",
        "userName": "የተጠቃሚ ስም",
        "email": "ኢሜይል",
        "membershipType": "የአባልነት አይነት",
        "membershipValidity": "የአባልነት ትክክለኛነት",
        "membershipRemainingDays": "የቀሩት ቀናት ብዛት",
        "membershipRole": "የአባልነት ሚና",
        "accountProgress": "የመለያ እድገት",
        "status": "ሁኔታ",
        "active": "ንቁ",
        "deactivated": "ቦዝኗል",
        "continue": "ቀጥል",
        "questions": "ጥያቄዎች",
        "responses": "ምላሾች",
        "deleteSurvey": "የዳሰሳ ጥናት ሰርዝ",
        "editSurvey": "የዳሰሳ ጥናት ያርትዑ",
        "type": "ዓይነት",
        "compulsory": "የግዴታ",
        "createSurvey": "የዳሰሳ ጥናት ይፍጠሩ",
        "surveyBuilder": "የዳሰሳ ጥናት ገንቢ",
        "surveyList": "የዳሰሳ ዝርዝር",
        "farm": "እርሻ",
        "responseDate": "የምላሽ ቀን",
        "viewSurvey": "የዳሰሳ ጥናት ይመልከቱ",
        "question": "ጥያቄ",
        "settings": "ቅንብሮች",
        "addQuestion": "ጥያቄ ጨምር",
        "surveysSubmitted": "ጥናቶች ገብተዋል።",
        "surveyDetail": "የዳሰሳ ጥናት ዝርዝር",
        "conditionStatus": "የሁኔታ ሁኔታ",
        "conditionStatusDesc": "ሁኔታዎችን የሚያሟሉ ተጠቃሚዎች ለዳሰሳ ጥናቱ በራስ ሰር ብቁ ይሆናሉ።",
        "endSurvey": "የመጨረሻ ዳሰሳ",
        "publishSurvey": "የዳሰሳ ጥናት ያትሙ",
        "copy": "ቅዳ",
        "view": "ይመልከቱ",
        "startDate": "የመጀመሪያ ቀን",
        "endDate": "የመጨረሻ ቀን",
        "chooseDate": "ቀን ይምረጡ",
        "select": "ይምረጡ",
        "addSurveyQuestion": "የዳሰሳ ጥያቄ ያክሉ",
        "editSurveyQuestion": "የዳሰሳ ጥያቄን ያርትዑ",
        "questionScore": "የጥያቄ ነጥብ",
        "mandatory": "የግዴታ",
        "yes": "አዎ",
        "no": "አይ",
        "options": "አማራጮች",
        "typeHere": "እዚህ ይተይቡ",
        "add": "አክል",
        "optionsHint": "እባክህ መልስ ለመጨመር አስገባ ወይም አክል ላይ ጠቅ አድርግ",
        "surveyProgress": "የዳሰሳ ጥናት በሂደት ላይ ነው።",
        "allResponses": "የሁሉም ምላሾች ማጠቃለያ",
        "responseQuestion": "በጥያቄ የተሰጡ ምላሾች",
        "dateSubmitted": "የገባበት ቀን",
        "answer": "መልሶች",
        "totalScore": "ጠቅላላ ነጥብ",
        "score": "ነጥብ",
        "singleSelection": "ነጠላ ምርጫ",
        "multipleSelection": "ባለብዙ ምርጫ",
        "if": "ከሆነ",
        "then": "ከዚያም",
        "noResponse": "መልስ የለም",
        "noSurveyFound": "ምንም ጥናቶች አልተገኙም።",
        "createNewSurvey": "እባክዎ ከላይ ያለውን &quot;የዳሰሳ ጥናት ፍጠር&quot; የሚለውን ቁልፍ በመጠቀም የዳሰሳ ጥናት ይፍጠሩ",
        "cannotPublish": "የአካል ጉዳተኛ የዳሰሳ ጥናት ማተም አልተቻለም!",
        "deleteSurveyWarn": "የዳሰሳ ጥናቱን መሰረዝ መፈለግዎን እርግጠኛ ነዎት። ሁሉንም የዳሰሳ ጥናቶች ከሰረዙት ጥያቄዎች እና ማስገባቶች እስከመጨረሻው ይሰረዛሉ።",
        "noQuestionFound": "ምንም ጥያቄዎች አልተገኙም።",
        "createQuestion": "እባኮትን መጀመሪያ ከላይ ያለውን &quot;ጥያቄዎችን ጨምር&quot; የሚለውን ቁልፍ በመጠቀም ጥያቄ ጨምሩ",
        "deleteQuestion": "እርግጠኛ ነህ ጥያቄውን መሰረዝ ትፈልጋለህ?",
        "applyChanges": "እነዚህን ለውጦች እንዴት ተግባራዊ ማድረግ ይፈልጋሉ?",
        "editFutureSurveys": "የወደፊት ዳሰሳዎችን ብቻ ያርትዑ",
        "editLiveSurveyOnly": "የቀጥታ ዳሰሳን ብቻ ያርትዑ",
        "surveyIsLive": "እባክዎን የዳሰሳ ጥናቱ በአሁኑ ጊዜ በቀጥታ የሚሰራ መሆኑን እና በዚህ ጊዜ ጥያቄን ማርትዕ በቀደሙት ግቤቶች ላይ ተጽእኖ ሊያሳድር እንደሚችል ልብ ይበሉ። ማንኛውንም ችግር ለማስወገድ፣ በጥያቄዎቹ ላይ ለውጦችን ለማድረግ የዳሰሳ ጥናቱ ቅጂ መፍጠር ሊያስቡበት ይችላሉ።",
        "clickToCopy": "የዳሰሳ ቅጂ ለመፍጠር እዚህ ጠቅ ያድርጉ",
        "applyChangesNow": "ለውጦችን አሁን ተግብር",
        "copySurvey": "የዳሰሳ ጥናት ቅዳ",
        "changeCopySurveyName": "የተቀዳውን የዳሰሳ ሥሪት ስም መቀየር ትችላለህ።"
    },
    "dashboardReports": {
        "appDataReports": "የመተግበሪያ ውሂብ ሪፖርቶች",
        "reports": "ሪፖርቶች"
    },
    "cropsReport": "የሰብል ሪፖርት",
    "today": "ዛሬ",
    "week": "ሳምንት",
    "month": "ወር",
    "year": "አመት",
    "all": "ሁሉም",
    "cropsStatistics": "የሰብል ስታቲስቲክስ",
    "crops": "ሰብሎች",
    "acres": "ኤከር",
    "totalPlantedArea": "ጠቅላላ የተከለው ቦታ",
    "farmersChart": "የገበሬዎች ሰንጠረዥ",
    "farmsChart": "የእርሻ ገበታ",
    "cropsName": "የሰብል ስም",
    "farmers": "ገበሬዎች",
    "farms": "እርሻዎች",
    "planted": "ተክሏል",
    "plantedArea": "የተተከለው አካባቢ",
    "harvested": "የተሰበሰበ",
    "yieldAcre": "ምርት/ኤከር",
    "selectCrop": "ሰብልን ይምረጡ",
    "listByYield": "ዝርዝር በምርት።",
    "listByPlantedArea": "በተከለው ቦታ ዝርዝር",
    "equipmentReport": "የመሣሪያዎች ሪፖርት",
    "equipmentChart": "የመሳሪያዎች ገበታ",
    "selectFarmer": "ገበሬን ይምረጡ",
    "selectFarmers": "ገበሬዎችን ይምረጡ",
    "equipmentName": "የመሳሪያዎች ስም",
    "region": "ክልል",
    "counts": "ይቆጥራል።",
    "large": "ትልቅ",
    "medium": "መካከለኛ",
    "small": "ትንሽ",
    "listByFarmer": "ዝርዝር በገበሬ",
    "rowsPerPage": "ረድፎች በገጽ",
    "farmersReport": "የገበሬዎች ሪፖርት",
    "farmsReport": "የእርሻ ሪፖርት",
    "farmersStatistics": "የገበሬዎች ስታቲስቲክስ",
    "farmStatistics": "የእርሻ ስታቲስቲክስ",
    "averageFarmerLand": "አማካይ የገበሬ መሬት",
    "largeFarmers": "ትላልቅ ገበሬዎች",
    "mediumFarmers": "መካከለኛ ገበሬዎች",
    "smallFarmers": "አነስተኛ ገበሬዎች",
    "listByLand": "ዝርዝር በመሬት",
    "listByFarm": "ዝርዝር በእርሻ",
    "AvgLandAcre": "አማካኝ መሬት/አከር",
    "listbyCrop": "ዝርዝር በሰብል",
    "listbyZone": "በዞን ዝርዝር",
    "farmName": "የእርሻ ስም",
    "zones": "ዞኖች",
    "area": "አካባቢ",
    "goalsAchievedReport": "የተመዘገቡ ግቦች ሪፖርት",
    "listByCrops": "ዝርዝር በሰብል",
    "goalsAchievedChart": "የተሳኩ ግቦች ገበታ",
    "goalsAchieved": "የተሳኩ ግቦች",
    "goalsFailed": "ግቦች አልተሳኩም",
    "successRate": "የስኬት ደረጃ",
    "achieved": "ተሳክቷል።",
    "equipment": "መሳሪያዎች",
    "pests": "ተባዮች",
    "regions": "ክልሎች",
    "filterByCrops": "በሰብል አጣራ",
    "searchCrops": "ሰብሎችን ይፈልጉ",
    "batchCode": "ባች ኮድ",
    "batchRating": "የባች ደረጃ አሰጣጥ",
    "MakeASelection": "ምርጫ ያድርጉ",
    "typeTotalCoffeeQuantity": "ጠቅላላ የቡና መጠን ይተይቡ",
    "typeHumidity": "ዓይነት እርጥበት",
    "valueInPercent": "ዋጋ በ%",
    "purchaseOrderRequired": "የግዢ ትዕዛዝ ያስፈልጋል",
    "totalCoffeeCherryRequired": "ጠቅላላ የቡና ቼሪ ያስፈልጋል",
    "processTypeRequired": "የሂደቱ አይነት ያስፈልጋል",
    "stationInfo": "የጣቢያ መረጃ",
    "purchaseOrders": "የግዢ ትዕዛዞች",
    "processingBatch": "የማቀነባበሪያ ባች",
    "processedCoffeeOutRequired": "የተሰራ ቡና መውጣት ያስፈልጋል",
    "lotNo": "ዕጣ ቁጥር",
    "addNewS": "አዲስ አስገባ",
    "viewAll": "ሁሉንም ይመልከቱ",
    "parchmentOut": "ብራና ወጣ",
    "processingDone": "ሂደት ተከናውኗል",
    "farmerLotID": "ገበሬ",
    "weight": "ክብደት",
    "plantationSettings": "የእፅዋት ቅንብሮች",
    "PlantationsEachFarmerCanCreate": "እያንዳንዱ አርሶ አደር ሊፈጥረው የሚችለው የእፅዋት ቁጥር",
    "manageAdditionalPlantationRequests": "ተጨማሪ የመትከያ ጥያቄዎችን አስተዳድር",
    "autoApprove": "በራስ-አጽድቅ",
    "adminApprovalRequired": "የአስተዳዳሪ ማጽደቅ ያስፈልጋል",
    "close": "ገጠመ",
    "new_user": "አዲስ ተጠቃሚ",
    "KGAcre": "ኪጂ/አከር",
    "honey": "ማር",
    "naturalDry": "ተፈጥሯዊ (ደረቅ)",
    "wine": "ወይን",
    "SemiWashed": "በከፊል የታጠበ",
    "fullWashed": "ሙሉ-የታጠበ",
    "startDateRequired": "የመጀመሪያ ቀን ያስፈልጋል",
    "endDateRequired": "የማብቂያ ቀን ያስፈልጋል",
    "assigned": "ተመድቧል",
    "activated": "ነቅቷል",
    "unassigned": "ያልተመደበ",
    "deleteTopic": "ርዕስ ሰርዝ",
    "sureToDeleteTopic": "እርግጠኛ ነዎት ቴክኒካዊ ጉዳዮችን መሰረዝ ይፈልጋሉ?",
    "publishSurvey": "የዳሰሳ ጥናት ያትሙ",
    "endSurvey": "የመጨረሻ ዳሰሳ",
    "copy": "ቅዳ",
    "pending": "በመጠባበቅ ላይ",
    "Farmer Name": "የገበሬ ስም",
    "Goals Achieved": "የተሳኩ ግቦች",
    "Goals Failed": "ግቦች አልተሳኩም",
    "Success Rate": "የስኬት ደረጃ",
    "Equipment Name": "የመሳሪያዎች ስም",
    "Farmer": "ገበሬ",
    "Counts": "ይቆጥራል።",
    "Pest Name": "የተባይ ስም",
    "Total Area": "ጠቅላላ አካባቢ",
    "Region": "ክልል",
    "Crop": "ሰብል",
    "Crop Name": "የሰብል ስም",
    "Farmers": "ገበሬዎች",
    "Farms": "እርሻዎች",
    "Planted": "ተክሏል",
    "Planted Area": "የተተከለው አካባቢ",
    "Harvested": "የተሰበሰበ",
    "Yield/acre": "ምርት/ኤከር",
    "Region Name": "የክልል ስም",
    "Avg. Land/Acre": "አማካኝ መሬት/አከር",
    "Crops": "ሰብሎች",
    "Yield/area": "ምርት/አካባቢ",
    "Avg. land/Acre": "አማካኝ መሬት / ኤከር",
    "Farm Name": "የእርሻ ስም",
    "Zones": "ዞኖች",
    "Area": "አካባቢ",
    "Goals Achieved Report": "የተመዘገቡ ግቦች ሪፖርት",
    "Farms Report": "የእርሻ ሪፖርት",
    "Pest Report": "የተባይ ሪፖርት",
    "Equipment Report": "የመሣሪያዎች ሪፖርት",
    "Crops Report": "የሰብል ሪፖርት",
    "Farmers Report": "የገበሬዎች ሪፖርት",
    "Regional Report": "የክልል ሪፖርት",
    "oma": {
        //land suitability
        "landSuitibility": "በህክምና መስክ",
        "landSuitibilityReport": "በህክምና እቅድ",
        "generateNewReport": "አዲስ እቅድ ተመልክቶ በይነመረቡ",
        "operatorName": "ሰራተኛው ስም",
        "issueDate": "የማስነሳቸው ቀን",
        "chooseYourLocation": "የምረጡትን አካባቢ ምረጥ",
        "getLandEvaluation": "መረጃውን ለማውጣት በመጠቀም በህክምና ምዝግባ ተጠቅመው ተመልክቶ ይጠቀሙ",
        "downloadPdfReport": "እቅዱን ለመስጠት PDF አጋረጋላቸው",
        "pleaseEnterCoordinateText": "ህክምና ቦታውን ለመጠቀም ስህተት (ላንግስት እና ልብስ) ያስገቡ።",
        "noRecordAvailable": "የሚገኙት መረጃ የለም።",
        "overallScoreForLand": "በህክምና ምዝግባ የሚቆጠሩ ሁኔታዎች",
        "landEvaluation": "በህክምና መረጃ",
        "unsuitable": "አልተመኘ",
        "marginally": "በጣም መነበብ",
        "suitable": "መሆንዎት",
        "moderately": "በአንድ መነበብ",
        "highly": "በሂደት",
        "back": "ተመለስ",
        "search": "ፈልግ",
        "showResults": "የተመረጡ ውጤቶች",

        //weather analysis
        "weatherAnalysisReport": "የማህበር ስትራትጃን እቅድ",
        "weatherAnalysis": "የማህበር ስትራትጃን",
        "getWeatherAnalysis": "የማህበር ስትራትጃን መረጃ ለመጠቀም",
        "weatherReport": "የማህበር ስትራትጃ ሥነ-ስርዓት",
        "filterByDate": "በቀኑ በመጠቀም ማውጣት",
        "insertCoordinateText": "በህክምና (ወደ አንድ ስክን) ቦታውን በማየት በላይ እናይፍታለን ከህክምና (ወደ አንድ ስክን) ቦታውን በማየት በማስነሳት ያልተላበራችሁ እየተጠቀሙ ይጠቀሙ።",
        "addTreeGeolocation": "የአንድ አካባቢ ግንኙነ",

        "valueAtTheCoordinatesOfInterest": "የሚከሰት ቦታን ስለሚያወርድ ነው",
        "Slope (%)": "አዶ (%)",
        "Soil texture (USDA class)": "ባህላዊ ቅባት (ኤስድየ ድርጅቶች)",
        "Coarse fragments (vol%)": "ከፍተኛ እብድን (ከፍተኛ%)",
        "Land": "መንደር",
        "Artificial surfaces (type)": "አልጋዎች ተለዋዋጭ (አይነት)",
        "Proximity to Type 1 and 2 Roads (meters)": "የአይነት 1 እና 2 መንገድን ተንከባቢዎች (ሜትር)",
        "Soil Chemical Properties": "ባህላዊ ከፍተኛ መስክ",
        "Soil Physical Properties": "ባህላዊ መንሸኝ መስክ",
        "Soil organic carbon (%)": "ባህላዊ የምጣል ካርቦን (%)",
        "Soil pH": "ባህላዊ ፒስ",
        "Soil salinity (ECe))": "ባህላዊ ወጋ (ECe)",
        "Mean annual temperature (°C)": "የዓመቱ የቀን ሠዓት የተመዘገበ የጥበቃ ሽያጭ (°C)",
        "Weather": "የአየር ሁኔታ",
        "Mean minimum temperature of coldest month (°C)": "የውስጥ ወደ እንቅስቃሴ ብዛት እናት የጥበቃ ሽያጭ (°C)",
        "Mean annual precipitation (mm)": "የዓመቱ የአካባቢ ውሃ ሙያ (mm)",

    },

    deforestation: {
        eudrComplianceStatus: 'EUDR ተገዢነት ሁኔታ',
        deforestationComplianceReport: 'የእንጨት ማስታወቂያ መግቢያ እቅዶች',
        noDeforestationComplianceReport: 'የእንጨት ማስታወቂያ መግቢያ እቅድ አልተገኘም',
        loadingDeforestationComplianceReport: 'የእንጨት ማስታወቂያ መግቢያ እቅድን በመጫን ላይ',
        farmName: 'የእርሻ ስም',
        farmRegistrationId: 'የእርሻ ምዝገባ መለያ',
        farmerName: 'የገበሬ ስም',
        farmerRegistrationId: 'የገበሬ ምዝገባ መለያ',
        uniqueFarmerId: "በተለየ ሁኔታ የገበሬ መለያ",
        uniqueFarmId: "በተለየ ሁኔታ የእርሻ መለያ",
        farmLocation: 'የእርሻ አካባቢ',
        area: 'አካባቢ',
        farmAddress: 'የእርሻ አድራሻ',
        dateOfRequest: 'የመጠየቂያ ቀን',
        status: 'ሁኔታ',
        settings: 'ቅንብሮች',
        
        farmLatitude: 'የእርሻ ሜዳው ምድብ',
        farmLongitude: 'የእርሻ ምድብ ክንድ',
        shareQRCode: 'QR ኮድ አጋራ',
        copy: 'ቅዳ',
    
        allCountries: 'ሁሉም አገራት',
        allRegions: 'ሁሉም ክልሎች',
        allFarms: 'ሁሉም እርሻዎች',
        viewCertificate: 'ምስክር ወረቀትን እይ',
    
        assignmentIssued: 'መደብ ተሰጥቷል',
    
        complianceCertification: 'የተሻለኝነት ምስክር ወረቀት',
        noComplianceCertification: 'የተሻለኝነት ምስክር ወረቀት አልተገኘም',
        loadingComplianceCertification: 'የተሻለኝነት ምስክር ወረቀትን በመጫን ላይ',
    
        eudrForestAssessment: 'የEUDR ጫካ ግምገማዎች',
        assessmentReport: 'ግምገማ ሪፖርት',
        downloadPDF: 'PDF አውርድ',
        back: 'ተመለስ',
        farmDetails: 'የእርሻ ዝርዝሮች',
    
        dimitraFarmId: 'የዲሚትራ እርሻ መለያ',
        dimitraFermerId: 'የዲሚትራ ገበሬ መለያ',
    
        totalGeofenceAreaHA: 'ጠቅላላ የግድብ አካባቢ (በአካባቢ)',
        forestLossHA: 'የጫካ ማስጣት (በአካባቢ)',
        forestGainHA: 'የጫካ ጥቅም (በአካባቢ)',
        forestUnchangedHA: 'ጫካ እንደዚሁ ያለ (በአካባቢ)',
        shareCertificate: 'ምስክር ወረቀትን አጋራ',
        forestUnchanged: 'ጫካ እንደዚሁ ያለ',
        forestLoss: 'ጫካ ማስጣት',
        forestGain: 'ጫካ ጥቅም',
        totalGeofenceArea: 'ጠቅላላ የግድብ አካባቢ',
        print: 'አትም',
        deforestationProbability: "የእንጨት እጣ እድል",
        colorCode: "ቀለም ኮድ",
        geofenceArea: "የግድብ አካባቢ",
        percentageOfGeofenceArea: "የግድብ አካባቢ በመቶ",
        view: 'እይ',
        customization: "ቅንብር",
        recordsPerpage: "በወር ምዝገቦች",
        restoreDefault: "ነባሪን አስመልስ",
        apply: "አተግብር",
        forestAssessmentHelp: 'በዚህ ሪፖርት ላይ ጥያቄዎች ካሉዎት ወይም ማስተማር ያስፈልግዎት እንዴት እንደሚችሉ ለመረዳት እኛን በማገዛት አገልግሎት እናነጋግሩ።',
        overallDeforestationProbability: 'ጠቅላላ የእንጨት እጣ እድል',
        zeroOrNegligible: 'ዜሮ/በጣም አነስተኛ',
        high: 'ከፍተኛ',
        allStatus: 'ሁሉም ሁኔታ',
        low: 'ዝቅተኛ',
        veryHigh: 'በጣም ከፍተኛ',
        medium: 'መካከለኛ',
        veryLow: 'በጣም ዝቅተኛ',
        assessmentIssued: 'ግምገማ ተሰጥቷል',
        certificateIssued: 'ምስክር ወረቀት ተሰጥቷል',
        assessmentNo: 'ግምገማ ቁጥር',
        blockchainCertificateDesc: "የብሎክቺን ምስክር እውነተኝነት ማረጋገጫ ሃሽ በምስክር ወረቀት እንደተቀበሉ ትገኛላችሁ",
        blockchainValidation: "የብሎክቺን ምስክር እውነተኝነት",
        openBlockchainPage: "የብሎክቺን ገጽን ክፈት",
        clickLinkDesc: "ላይኛውን አገናኝ በመጫን ምስክር ወረቀትን በብሎክቺን አረጋግጥ",
        tooltip: {
            dimitraFarmId: "በዲሚትራ ስርዓት ውስጥ ከተወሰነ እርሻ ጋር የተያያዘ ተለየ መለያ.",
            farmName: "የተጠቀሰው የእርሻ ስም.",
            farmRegistrationId: "የእርሻ ምዝገባ ቁጥር.",
            farmLocation: "የእርሻ ልዩ የጂኦግራፊ አካባቢ ወይም አካባቢ.",
            dimitraFermerId: "በዲሚትራ ስርዓት ውስጥ ከግለሰባዊ ገበሬ ጋር የተያያዘ ተለየ መለያ.",
            farmerName: "በእርሻ ዙሪያ የሚጠይቁት ግለሰብ.",
            farmerRegistrationId: "የገበሬ ምዝገባ ቁጥር.",
            assessmentNo: "እርሻ ግምገማ የተሰጠ ቁጥር."
        },
        "red": "ቀይ",
        "Yellow": "ቢጫ",
        transparent: "ዕንታ",
        darkRed: 'ጣት ቀለበት',
        brightRed: 'ቀለበት በተመሳሳይ',
        orange: 'ኦራንግ',
        lightBlue: 'አስራ በላይ',
        teal: 'ጠቅላላ',
        zeroOrNegligibleProbability: "ዜሮ/በጣም አነስተኛ የእንጨት እጣ እድል",
        riskDetected: "አደጋ ተለይቷል",
        zeroOrNegligibleRisk: "ዜሮ/በጣም አነስተኛ አደጋ",
        manuallyMitigated: "በእጅ የተቀነሰ",
        compliant: "ተስማሚ",
        nonCompliant: "ተስማሚ ያልሆነ",
        veryLowProbability: "በጣም ዝቅተኛ የእንጨት እጣ እድል",
        lowProbability: "ዝቅተኛ የእንጨት እጣ እድል",
        mediumProbability: "መካከለኛ የእንጨት እጣ እድል",
        highProbability: "ከፍተኛ የእንጨት እጣ እድል",
        veryHighProbability: "በጣም ከፍተኛ የእንጨት እጣ እድል",
        locationName: 'የቦታ ስም',
    },
    pleaseAgreeToDeclaration: "እባክዎን ለመጨረስ ከመግለጫው ጋር ይስማሙ።",
    importProductionPlaceTT: "ተጠቃሚዎችን የምርት ቦታ ዳታ በፋይል ማስገባት ወይም ማውረድ አማራጭ በመጠቀም ማስመጣት ይፈቅዳል።",
    defaultCircularGeofence: "ጂኦፌንስ የሌላቸው ወይም ስለ መጠኑ መረጃ የሌላቸው እርሻዎች እንደ ነባሪ ክብ ጂኦፌንስ የ 4 ሄክታር ይሰጣሉ። የእርሻው አማካይ መጠን ከ 4 ሄክታር በታች ከሆነ፣ እባክዎን ነባሪ መጠኑን በታች ባለው የ 'አርትዕ' አዝራር በመጫን ይቀይሩ።",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "እንደ EUDR እንደሚሆን ከ 4 ሄክታር በታች ያሉ እርሻዎች አራት ማዕዘን አያስፈልጋቸውም።",
    uploadOneDeforestationAssessmentForAllFarms: "ለሁሉም እርሻዎች አንድ የደን ጭፍጨፋ ግምገማ ያስገቡ",
    uploadAssessment: "ግምገማ ያስገቡ",
    noUploadToBlockchain: "ወደ ብሎክቼን ምንም ማስገባት አልተካሄደም",
    noDataForBlockchain: "ስለ እንስሳት ማህበረሰቦች የተሰጠው የደን ጭፍጨፋ ሪፖርት አልተመነጨም ስለዚህ ወደ ብሎክቼን ለመጻፍ መረጃ አልነበረም። ይህ ያልተጠበቀ ከሆነ፣ በቀድሞው ደረጃ ሪፖርቶች በትክክል እንደተመነጨ እባክዎን ያረጋግጡ።"
}